<template>
    <div class="info-window">
        <div class="window">
            <div>
                <img src="@/assets/mockup/mc-garage.jpg" alt=""/>
            </div>
            <div class="col-span-2 flex flex-col w-full h-full">
                <div class="flex-auto text-16 font-medium text-a-black-555555">
                    {{ selectedPlace.name }}
                </div>
                <div class="flex-none flex justify-between items-end">
                    <div class="text-a-black-484848 text-22 font-medium">
                        {{ minutes }} นาที
                    </div>
                    <div class="text-a-black-484848 text-12 font-light">
                        {{ distance }} กม.
                    </div>
                    <div>
                        <MainButton :minWidth="68" class="transform translate-y-2"
                            @click="gMapButton.onClick(selectedPlace.location.latitude, selectedPlace.location.longitude)">
                            เริ่ม
                        </MainButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MainButton from '@/components/Button/MainButton.vue';
import useGoogleMapButton from '@/helper/composable/useGoogleMapButton';
import { computed, defineComponent } from 'vue';

export default defineComponent({
    props: {
        selectedPlace: {
            type: Object,
            default: null
        },
        tripInfo: {
            type: Object,
            default: null
        }
    },
    setup: function (props) {
        const gMapButton = useGoogleMapButton()

        const minutes = computed(() => {
            if (props.tripInfo != null) {
                return Math.ceil(props.tripInfo.duration_in_traffic.value / 60)
            }
            return 0
        })

        const distance = computed(() => {
            if (props.tripInfo != null) {
                return (props.tripInfo.distance.value / 1000).toFixed(1)
            }
            return 0
        })

        return {
            minutes,
            distance,
            gMapButton
        }
    },
    components: { MainButton }
})
</script>

<style lang="scss" scoped>
.info-window {
    z-index: 1030;
    @apply fixed left-0 bottom-0 right-0 mx-auto max-w-lg;

    .window {
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        @apply m-2.5 px-3 py-4 rounded-10 bg-white grid grid-cols-3 gap-3;
    }
}
</style>
